export default {
  name: 'UserAgreementIos'
};